import script from "./ContractPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContractPage.vue?vue&type=script&setup=true&lang=ts"

import "./ContractPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__